<template>
  <b-row id="widthElement" class="px-sm-4 px-md-4 px-lg-0 pt-sm-3">
    <b-col cols="12" class="d-flex align-items-center justify-content-between">
      <PageTitle title="Lista de pedidos" />

      <div class="ml-2">
        <b-button pill variant="primary" title="Atualizar" @click="list()">
          <i class="fas fa-retweet "></i>
        </b-button>
      </div>
    </b-col>

    <b-col cols="12" class="mt-3">
      <b-button
        class="mr-3"
        variant="danger"
        @click="$refs.videoManual.toggleOpen({
          url: 'https://www.youtube.com/watch?v=5EJMuugqxsk&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=12',
          title: 'Lista de pedidos'
        })"
      >
        <i class="fas fa-play mr-1"></i>
        Ver video
      </b-button>
      <a
        class="btn btn-success"
        href="https://api.construp.com.br/assets/Pedidos App (2).pdf"
        target="_blank"
        download
      >
        <i class="fas fa-file-pdf c-white"></i>
        Baixar Manual
      </a>
    </b-col>

    <b-col cols="12" class="mb-4 mt-4">
      <PeriodsFilters
        ref="periodsFilters"
        :setDatesAutomatic="false"
        :startDate.sync="fields.startDate"
        :endDate.sync="fields.endDate"
        @click.native="list()"
      />
    </b-col>

    <b-col cols="12">
      <h5 class="font-weight-bold">Status do pedido</h5>
      <div>
        <h4 class="d-flex align-items-center flex-wrap" style="gap: 10px">
          <b-badge
            :variant="
              fields.status.includes(ORDER_STATUS.SEPARATING_ORDER)
                ? 'primary'
                : 'light'
            "
            class="pointer"
            @click="addStatus(ORDER_STATUS.SEPARATING_ORDER)"
          >
            {{ getOrderStatusText(ORDER_STATUS.SEPARATING_ORDER) }}
          </b-badge>
          <b-badge
            :variant="
              fields.status.includes(ORDER_STATUS.WAITING_PAYMENT)
                ? 'primary'
                : 'light'
            "
            class="pointer"
            @click="addStatus(ORDER_STATUS.WAITING_PAYMENT)"
          >
            {{ getOrderStatusText(ORDER_STATUS.WAITING_PAYMENT) }}
          </b-badge>
          <b-badge
            :variant="
              fields.status.includes(ORDER_STATUS.SENT) ? 'primary' : 'light'
            "
            class="pointer"
            @click="addStatus(ORDER_STATUS.SENT)"
          >
            {{ getOrderStatusText(ORDER_STATUS.SENT) }}
          </b-badge>
          <b-badge
            :variant="
              fields.status.includes(ORDER_STATUS.READY_FOR_PICKUP)
                ? 'primary'
                : 'light'
            "
            class="pointer"
            @click="addStatus(ORDER_STATUS.READY_FOR_PICKUP)"
          >
            {{ getOrderStatusText(ORDER_STATUS.READY_FOR_PICKUP) }}
          </b-badge>
          <b-badge
            :variant="
              fields.status.includes(ORDER_STATUS.DELIVERED)
                ? 'primary'
                : 'light'
            "
            class="pointer"
            @click="addStatus(ORDER_STATUS.DELIVERED)"
          >
            {{ getOrderStatusText(ORDER_STATUS.DELIVERED) }}
          </b-badge>
          <b-badge
            :variant="
              fields.status.includes(ORDER_STATUS.CANCELED)
                ? 'primary'
                : 'light'
            "
            class="pointer"
            @click="addStatus(ORDER_STATUS.CANCELED)"
          >
            {{ getOrderStatusText(ORDER_STATUS.CANCELED) }}
          </b-badge>
          <b-badge
            :variant="
              fields.status.length === Object.keys(ORDER_STATUS).length
                ? 'primary'
                : 'light'
            "
            class="pointer"
            @click="addAllStatus()"
          >
            Todos
          </b-badge>
        </h4>
      </div>
    </b-col>

    <b-col cols="12 mt-2">
      <h5 class="font-weight-bold">Tipo de pagamento</h5>
      <div>
        <h4 class="d-flex align-items-center flex-wrap" style="gap: 10px">
          <b-badge
            :variant="
              fields.paymentType.includes(PAYMENT_METHODS.PIX)
                ? 'primary'
                : 'light'
            "
            class="pointer"
            @click="addStatusPayment(PAYMENT_METHODS.PIX)"
          >
            {{ getPaymentStatusText(PAYMENT_METHODS.PIX) }}
          </b-badge>

          <b-badge
            :variant="
              fields.paymentType.includes(PAYMENT_METHODS.CREDIT_CARD)
                ? 'primary'
                : 'light'
            "
            class="pointer"
            @click="addStatusPayment(PAYMENT_METHODS.CREDIT_CARD)"
          >
            {{ getPaymentStatusText(PAYMENT_METHODS.CREDIT_CARD) }}
          </b-badge>

          <b-badge
            :variant="
              fields.paymentType.includes(PAYMENT_METHODS.BOLETO)
                ? 'primary'
                : 'light'
            "
            class="pointer"
            @click="addStatusPayment(PAYMENT_METHODS.BOLETO)"
          >
            {{ getPaymentStatusText(PAYMENT_METHODS.BOLETO) }}
          </b-badge>

          <b-badge
            :variant="
              fields.paymentType.includes(PAYMENT_METHODS.WALLET)
                ? 'primary'
                : 'light'
            "
            class="pointer"
            @click="addStatusPayment(PAYMENT_METHODS.WALLET)"
          >
            {{ getPaymentStatusText(PAYMENT_METHODS.WALLET) }}
          </b-badge>

          <b-badge
            :variant="
              fields.paymentType.includes(PAYMENT_METHODS.SHOPKEEPER_PAYMENT)
                ? 'primary'
                : 'light'
            "
            class="pointer"
            @click="addStatusPayment(PAYMENT_METHODS.SHOPKEEPER_PAYMENT)"
          >
            {{ getPaymentStatusText(PAYMENT_METHODS.SHOPKEEPER_PAYMENT) }}
          </b-badge>

          <b-badge
            :variant="
              fields.paymentType.length === Object.keys(PAYMENT_METHODS).length
                ? 'primary'
                : 'light'
            "
            class="pointer"
            @click="addAllStatusPayment()"
          >
            Todos
          </b-badge>
        </h4>
      </div>
    </b-col>

    <b-col cols="6" class="mt-3">
      <input
        type="text"
        v-model.trim="fields.clientName"
        class="form-control"
        placeholder="Nome do cliente"
      />
    </b-col>

    <b-col cols="2" class="mt-3">
      <input
        min="0"
        type="number"
        v-model.number="fields.orderNumber"
        @input="handleOrderNumber()"
        class="form-control"
        placeholder="Número do pedido"
      />
    </b-col>

    <b-col cols="4" class="mt-3">
      <select class="form-control" v-model="fields.vendedor">
        <option value="">-- Vendedor -- </option>
        <option v-for="(item, i) in balconistas" :key="i" :value="item.id">
          {{item.name}}
        </option>
      </select>
    </b-col>

    <b-col cols="12" class="mt-3">
      <span>
        <b-button variant="success" @click="list()">
          <i class="fas fa-search mr-2"></i>
          Pesquisar
        </b-button>
      </span>
    </b-col>

    <b-col cols="6" class="mt-4">
      <h3 class="title font-weight-bold">
        {{ pagination.total }} pedidos encontrados
      </h3>
    </b-col>

    <b-col cols="6" class="text-right mt-4">
      <b-button
        v-if="!generatingSpreadsheet"
        class="mr-2"
        variant="primary"
        @click="generateProductsPayment()"
      >
        <i class="fas fa-file-download mr-2"></i>
        Planilha de produtos do pedido
      </b-button>

      <b-button
        v-if="!generatingSpreadsheet"
        variant="success"
        @click="generateSpreadsheet()"
      >
        <i class="fas fa-file-download mr-2"></i>
        Planilha de pedidos
      </b-button>
      <b-spinner v-else variant="success" label="Spinning"></b-spinner>
    </b-col>

    <b-col cols="12">
      <b-table
        striped
        hover
        show-empty
        empty-text="Sem produtos encontrados"
        :fields="table.headers"
        :items="table.records"
        :busy="loading"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Carregando...</strong>
          </div>
        </template>
        <template #cell(date)="data">
          <div>
            {{ data.item.date }}
          </div>
          <div
            v-if="data.item.hasExternalIntegration"
            title="A entrega deste pedido será realizado por outra empresa"
          >
            <b-badge variant="warning">
              <i class="fas fa-exclamation-triangle mr-1"></i> Entrega por
              terceiros
            </b-badge>
          </div>
        </template>
        <template #cell(totalValue)="data">
          {{ formatNumber(data.item.totalValue) }}
        </template>
        <template #cell(paymentType)="data">
          {{ getPaymentTypeText(data.item.paymentType) }}
        </template>
        <template #cell(origem)="data">
          {{ data.item.purchaseOrigin }}
        </template>
        <template #cell(orcamentoId)="data">
          <div v-if="userTypeId() == 4477">
            {{data.item.invoiceNumber}}
          </div>
          <div v-else>
            {{ data.item.orcamentoId != null ? 'Sim' : 'Não' }}

            <span
              v-if="data.item.orcamentoId != null"
              class="btn btn-dark btn-sm ml-2"
              v-b-tooltip.hover
              :title="'Vendedor: ' + formatarBalconista(data.item.idBalconista)"
            >
              <i class="fas fa-question-circle"></i>
            </span>
          </div>
        </template>
        <template #cell(status)="data">
          <SelectItems
            v-if="data.item.editing"
            label="name"
            v-model="fields.selectedOrders[`${data.item.id}`].newStatus"
            :items="
              data.item.delivery == 'delivery'
                ? orderStatusItems
                : orderStatusItemStore
            "
            :loading="loading"
            :reduceFunction="(orderStatus) => orderStatus.id"
            placeholder="Novo status"
          />

          <div v-else :class="colorText(data.item.status)">
          <OrderDetails
            ref="orderDetails"
            :data="data"
            @get="list()"
          />
            <div>{{ getOrderStatusText(data.item.status, data.item.paymentType) }}</div>
            <div
              v-if="data.item.status === ORDER_STATUS.CANCELED"
              class="badge badge-danger"
            >
              Não pago
            </div>
            <div v-if="isPaid(data.item.status) && data.item.paymentType != 'shopkeeper'" class="badge badge-success">
              Pago
            </div>
            <div v-if="data.item.paymentType == 'shopkeeper'" class="badge badge-dark">
              Recebimento com a loja
            </div>
          </div>
          <div
            v-if="
              data.item.status === ORDER_STATUS.WAITING_PAYMENT &&
              (data.item.paymentType == 'all' ||
                data.item.paymentType == 'pix' ||
                data.item.paymentType == 'wallet' ||
                data.item.paymentType == 'shopkeeper'
              )
            "
            class="countdown"
          >
            <flip-countdown
              :deadline="data.item.time"
              countdownSize="1rem"
              labelSize=".7rem"
              :labels="{
                days: 'Dias',
                hours: 'Hrs.',
                minutes: 'Min.',
                seconds: 'Seg.',
              }"
            >
            </flip-countdown>
          </div>
        </template>
        <template #cell(actions)="data">
          <b-col class="pr-0 d-flex">
            <div v-if="data.item.editing" class="d-inline-block">
              <b-button
                variant="success"
                size="sm"
                v-b-tooltip.hover
                title="Salvar"
                class="mr-1 mb-1 d-none d-md-block"
                id="updateStatusButton"
                @click="
                  fields.selectedOrders[`${data.item.id}`].newStatus ===
                  ORDER_STATUS.DELIVERED
                    ? confirmUpdateStatusWhenFinishedorCancel(data.item.id, data.item.paymentType)
                    : updateStatus({
                        id: data.item.id,
                        newStatus: fields.selectedOrders[`${data.item.id}`].newStatus
                      })
                "
              >
                <i class="fas fa-save"></i>
              </b-button>
              <b-button
                variant="warning"
                size="sm"
                v-b-tooltip.hover
                title="Cancelar"
                class="mr-1 mb-1 d-none d-md-block"
                @click="cancelOrderEdit(data.item.id)"
              >
                <i class="fas fa-ban"></i>
              </b-button>
            </div>
            <b-button
              v-if="userTypeId() == 4477 && data.item.status > 1"
              variant="dark"
              size="sm"
              v-b-tooltip.hover
              title="Buscar NF-e"
              class="mr-1 mb-1 d-none d-md-block"
              @click="getNfeCarflax(data.item.id)"
            >
              <i class="fas fa-file-invoice-dollar"></i>
            </b-button>
            <b-button
              v-if="webhook && userTypeId() != 4402 && userTypeId() != 4439 && userTypeId() != 4465 && userTypeId() != 4477"
              variant="success"
              size="sm"
              v-b-tooltip.hover
              title="Reenviar pedido webhook"
              class="mr-1 mb-1 d-none d-md-block"
              @click="sendWebhook(data.item.id)"
            >
              <i class="fas fa-paper-plane"></i>
            </b-button>
            <b-button
              v-if="data.item.status === ORDER_STATUS.WAITING_PAYMENT && data.item.paymentType == 'shopkeeper'"
              variant="danger"
              size="sm"
              v-b-tooltip.hover
              title="Não aceitar pedido"
              class="mr-1 mb-1 d-none d-md-block"
              @click="statusPedidoLoja(data.item.id, false)"
            >
              <i class="fas fa-times"></i>
            </b-button>
            <b-button
              v-if="data.item.status === ORDER_STATUS.WAITING_PAYMENT && data.item.paymentType == 'shopkeeper'"
              variant="success"
              size="sm"
              v-b-tooltip.hover
              title="Aprovar pedido"
              class="mr-1 mb-1 d-none d-md-block"
              @click="statusPedidoLoja(data.item.id, true, data.item.totalValue)"
            >
              <i class="fas fa-check"></i>
            </b-button>
            <b-button
              v-if="data.item.status != ORDER_STATUS.CANCELED && data.item.status != ORDER_STATUS.WAITING_PAYMENT"
              variant="warning"
              size="sm"
              v-b-tooltip.hover
              title="Devolução do pedido"
              class="mr-1 mb-1 d-none d-md-block"
              @click="returnPayment(data.item)"
            >
              <i class="fas fa-undo"></i>
            </b-button>
            <b-button
              variant="primary"
              size="sm"
              :disabled="data.item.status === ORDER_STATUS.EXPIRED"
              v-b-tooltip.hover
              :title="data.item.status === ORDER_STATUS.EXPIRED
                  ? 'Esse pedido não pode ser editado'
                  : 'Editar pedido'
              "
              class="mr-1 mb-1 d-none d-md-block"
              v-if="isEdit(data.item)"
              @click="editOrder(data.item.id)"
            >
              <i class="fas fa-edit"></i>
            </b-button>

            <b-button
              variant="warning"
              size="sm"
              :disabled="data.item.status === ORDER_STATUS.EXPIRED"
              v-b-tooltip.hover
              :title="data.item.status === ORDER_STATUS.EXPIRED
                  ? 'Não pode adicionar NF nesse pedido'
                  : 'Adicionar/Editar NF'
              "
              class="mr-1 mb-1 d-none d-md-block"
              @click="addInvoice(data.item)"
            >
              <i class="fas fa-file"></i>
            </b-button>

            <b-button
              variant="outline-dark"
              size="sm"
              v-b-tooltip.hover
              title="Detalhes do pedido"
              class="mr-1 mb-1"
              v-if="!data.item.editing"
              @click="
                $refs.orderDetails.toggleOpen({
                  orderId: data.item.id,
                  uuid: data.item.uuid,
                  dataModal: data.item
                })
              "
            >
              <i class="fas fa-eye"></i>
            </b-button>
            <b-button
              variant="success"
              size="sm"
              v-b-tooltip.hover
              title="Enviar para Citel"
              class="mr-1 mb-1"
              v-if="data.item.enviarPedido == true"
              @click="enviarCitel(data.item.id, data.item.construp_user_id)"
            >
              <i class="fas fa-paper-plane"></i>
            </b-button>
            <b-button
              size="sm"
              @click="
                $refs.melhorEnvioPaymentMethods.toggleOpen({
                  orderId: data.item.id,
                  shippingValue: data.item.shipping,
                })
              "
              v-if="
                data.item.hasExternalIntegration &&
                data.item.status === ORDER_STATUS.SEPARATING_ORDER &&
                !data.item.shippingPaid
              "
              variant="outline-warning"
              class="mr-1 mb-1"
              v-b-tooltip.hover
              title="Pagar frete da Melhor Envio"
            >
              <i class="fas fa-truck"></i>
            </b-button>
            <b-button
              size="sm"
              @click="printLabel(data.item.id)"
              v-if="
                data.item.hasExternalIntegration &&
                data.item.status === ORDER_STATUS.SEPARATING_ORDER &&
                data.item.shippingPaid
              "
              variant="outline-danger"
              class="mr-1 mb-1"
              :disabled="printing"
              v-b-tooltip.hover
              title="Imprimir etiqueta do Melhor Envio"
            >
              <i class="fas fa-tag" v-if="!printing"></i>
              <b-spinner
                style="width: 0.7rem; height: 0.7rem"
                label="Spinning"
                small
                v-else
              ></b-spinner>
            </b-button>
            <b-button
              size="sm"
              @click="sendFreight(data.item.id)"
              v-if="
                !data.item.hasExternalIntegration &&
                data.item.hasShippings &&
                data.item.status === ORDER_STATUS.SEPARATING_ORDER
              "
              variant="outline-danger"
              class="mr-1 mb-1"
              :disabled="loading"
              v-b-tooltip.hover
              title="Enviar frete para o Melhor Envio"
            >
              <i class="fas fa-parachute-box"></i>
            </b-button>
            <b-button
              size="sm"
              @click="getTrackingUrl(data.item.id)"
              v-if="
                data.item.hasExternalIntegration &&
                data.item.status === ORDER_STATUS.SEPARATING_ORDER &&
                data.item.shippingPaid
              "
              variant="outline-success"
              class="mr-1 mb-1"
              :disabled="gettingTrack"
              v-b-tooltip.hover
              title="Rastrear pedido"
            >
              <i class="fas fa-truck-loading" v-if="!gettingTrack"></i>
              <b-spinner
                style="width: 0.7rem; height: 0.7rem"
                label="Spinning"
                small
                v-else
              ></b-spinner>
            </b-button>
          </b-col>
        </template>
      </b-table>
    </b-col>
    <b-col cols="12" class="d-flex align-items-center justify-content-center">
      <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.itemsPerPage"
        :disabled="loading"
      ></b-pagination>
    </b-col>
    <b-popover
      v-if="showConfirmationPopover"
      :show.sync="showConfirmationPopover"
      target="updateStatusButton"
      title="Confirmação"
      triggers="click"
      placement="top"
      variant="warning"
    >
      Tem certeza que deseja alterar o status do pedido para
      <strong>entregue</strong>? Após isso não será possível editar o status do
      pedido.

      <div class="row">
        <div class="col-md-12 mt-4">
          <label>Quem recebeu o pedido?</label>
          <input type="text" class="form-control" v-model="received.name" />
        </div>
        <div class="col-md-12 mt-2">
          <label>CPF:</label>
          <input
            type="text"
            class="form-control"
            v-model="received.cpf"
            v-mask="'###.###.###-##'"
            placeholder="###.###.###-##"
          />
        </div>
        <div class="col-md-12 mt-2" v-if="tipoPedidoLoja == true">
          <label>Meio de pagamento utilizado:</label>
          <input
            type="text"
            class="form-control"
            placeholder="Ex: Pix, Cartão, Boleto"
            v-model="received.payment"
          />
        </div>

        <div class="col-6 mt-2">
          <b-button
            size="sm"
            block
            variant="outline-danger"
            class="ml-auto mr-2"
            @click="
              () => {
                currentOrderBeingEditedId = 0;
                showConfirmationPopover = false;
              }
            "
          >
            <i class="fas fa-times mr-2"></i>
            Fechar
          </b-button>
        </div>

        <div class="col-6 mt-2">
          <b-button
            size="sm"
            block
            variant="success"
            @click="
              updateStatus({
                id: currentOrderBeingEditedId,
                newStatus:
                fields.selectedOrders[`${currentOrderBeingEditedId}`].newStatus,
                popover: true,
              });
              currentOrderBeingEditedId = 0;
              showConfirmationPopover = false;
            "
          >
            <i class="fas fa-save mr-2"></i>
            Salvar
          </b-button>
        </div>
      </div>

    </b-popover>

    <b-modal
      title="Deseja realizar o estorno desse pedido?"
      id="modalReturnPayment"
      hide-footer
    >
      <div class="row" v-if="paymentReturn.paymentType">
        <div :class="paymentReturn.paymentType != 'credit_card' ? 'col-12' : 'col-6'">
          <label>Valor devolução: (R$)</label>
          <input
            type="text"
            class="form-control"
            v-model="paymentReturnValue"
            v-money="money"
            :disabled="paymentReturn.paymentType != 'credit_card'"
          >
        </div>

        <div class="col-6 d-flex flex-column justify-content-end" v-if="paymentReturn.paymentType == 'credit_card'">
          <button class="btn btn-primary btn-block" @click="paymentReturnValue = paymentReturn.totalValue">
            Valor integral
          </button>
        </div>

        <div class="col-12 text-center mt-4">
          <button class="btn btn-success pl-5 pr-5" @click="returnPayment(paymentReturn, false)">
            {{paymentReturn.paymentType != 'credit_card' ? 'Estornar pedido' : 'Estornar valor'}}
          </button>
        </div>
      </div>
    </b-modal>
    <VideoManual ref="videoManual"/>
    <PaymentMethods ref="melhorEnvioPaymentMethods" @paid="list()" />
    <SendFreight ref="sendFreight" @sent="list()" />
    <invoice-order-modal ref="invoiceOrder" @getAll="list()"/>
  </b-row>

</template>

<script>
import { mapActions, mapState } from 'vuex';
import * as XLSX from 'xlsx';

import { formatNumber } from '@/utils';
import UserTypes from '@/enums/UserTypes';
import ORDER_STATUS from 'Enums/Order/Status.js';
import PAYMENT_METHODS from 'Enums/PaymentMethods.js';
import TypePermission from '@/enums/Clerk/TypePermission';
import NamePermission from '@/enums/Clerk/NamePermission';

import PageTitle from '../../../components/PageTitle.vue';
import makeToast from '../../../mixins/makeToast';
import PeriodsFilters from 'Components/Inputs/PeriodsFilters.vue';
import SelectItems from 'Components/Inputs/SelectItems.vue';
import OrderDetails from 'Components/Order/OrderDetails.vue';
import FlipCountdown from 'vue2-flip-countdown';
import PaymentMethods from './MelhorEnvio/PaymentMethods.vue';
import SendFreight from './MelhorEnvio/SendFreight.vue';
import VideoManual from '@/components/VideoManual.vue';
import InvoiceOrderModal from '@/components/Order/InvoiceOrderModal.vue';

export default {
  name: 'OrdersAppList',
  mixins: [makeToast],
  components: {
    PageTitle,
    PeriodsFilters,
    SelectItems,
    OrderDetails,
    FlipCountdown,
    PaymentMethods,
    SendFreight,
    VideoManual,
    InvoiceOrderModal
  },
  data() {
    return {
      paymentReturn: {},
      paymentReturnValue: null,
      ORDER_STATUS,
      PAYMENT_METHODS,
      generatingSpreadsheet: false,
      printing: false,
      gettingTrack: false,
      loading: false,
      showConfirmationPopover: false,
      currentOrderBeingEditedId: 0,
      errorRequest: false,
      statusNow: '',
      isEditing: false,
      timeInterval:'',
      editStatusClerk: false,
      tipoPedidoLoja: false,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true,
      },
      received: {
        name: '',
        cpf: '',
        payment: '',
      },
      fields: {
        clientName: '',
        orderNumber: null,
        vendedor: '',
        startDate: '',
        endDate: '',
        status: [],
        paymentType: [],
        selectedOrders: {},
      },
      pagination: {
        currentPage: 1,
        itemsPerPage: 1,
        total: 0,
      },
      webhook: false,
      balconistas: [],
      table: {
        headers: [],
        records: [],
      },
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
    orderStatusItems() {
      const items = [];
      Object.keys(ORDER_STATUS).forEach((key) => {
        if (ORDER_STATUS[key] != 1 && ORDER_STATUS[key] != 7) {
          items.push({
            id: ORDER_STATUS[key],
            name: this.getOrderStatusText(ORDER_STATUS[key]),
          });
        }
      });
      return items;
    },
    orderStatusItemStore() {
      const items = [];
      Object.keys(ORDER_STATUS).forEach((key) => {
        if (ORDER_STATUS[key] != 1 && ORDER_STATUS[key] != 3) {
          items.push({
            id: ORDER_STATUS[key],
            name: this.getOrderStatusText(ORDER_STATUS[key]),
          });
        }
      });
      return items;
    },
    isPaid() {
      return (status) => {
        return (
          (status >= ORDER_STATUS.SEPARATING_ORDER &&
            status <= ORDER_STATUS.DELIVERED) ||
          status == ORDER_STATUS.READY_FOR_PICKUP
        );
      };
    },
  },
  watch: {
    'pagination.currentPage': function () {
      this.list();
    },
    isEditing: function () {
      this.isEditing ? this.stopTimerFunction() : this.timerFunction();
    },
  },
  mounted() {
    this.getHeaders();
    const webhook = localStorage.getItem('webhook');
    if(webhook) {
      this.webhook = webhook;
    }

    if (this.$route.query.statusPedido) {
      if (
        this.$route.query.statusPedido == '1' ||
        this.$route.query.statusPedido == '2' ||
        this.$route.query.statusPedido == '3' ||
        this.$route.query.statusPedido == '4' ||
        this.$route.query.statusPedido == '5' ||
        this.$route.query.statusPedido == '6' ||
        this.$route.query.statusPedido == '7'
      ) {
        this.fields.status[0] = parseInt(this.$route.query.statusPedido);
      } else if (this.$route.query.statusPedido == '2-3-4') {
        const status = this.$route.query.statusPedido.split('-');
        this.fields.status[0] = parseInt(status[0]);
        this.fields.status[1] = parseInt(status[1]);
        this.fields.status[2] = parseInt(status[2]);
      }
    }

    this.getAll();
    this.isEditing ? this.stopTimerFunction() : this.timerFunction();
  },

  methods: {
    formatNumber,
    ...mapActions('shopkeeper', [
      'getAppOrders',
      'getAppProductsOrders',
      'updateOrderStatus',
      'updateOrderStatusLoja',
      'enviarPedidoCitel',
      'enviarPedidoCitelEstrela',
      'enviarPedidoCitelAtena',
      'enviarPedidoCitelCarflax',
      'sendReturnPayment',
      'sendWebhookPayment',
      'sendWebhookPaymentBocao',
      'getNfeCarflaxPaymentId'
    ]),
    ...mapActions('integration', [
      'printMelhorEnvioLabel',
      'getTrackingMelhorEnvioUrl',
    ]),
    sendWebhook(id) {
      if (this.userTypeId() == 4485) {
        this.$store.dispatch('startLoader');
        this.sendWebhookPaymentBocao(id)
          .then(() => {
            this.makeToast('Sucesso!', 'Webhook enviado com sucesso!', 'success');
          })
          .catch(() => {
            this.makeToast('Opss!', 'Não foi possível reenviar o webhook do pedido!', 'danger');
          }).finally(() => {
            this.$store.dispatch('endLoader');
          })
      } else {
        const data = {
          paymentId: id,
          lojistaId: this.userTypeId()
        }

        this.$store.dispatch('startLoader');
        this.sendWebhookPayment(data)
          .then((response) => {
            if(response.data.error) {
              this.makeToast('Opss!', 'Não foi possível reenviar o webhook do pedido!', 'danger');
            } else {
              this.makeToast('Sucesso!', 'Webhook enviado com sucesso!', 'success');
            }
          })
          .catch(() => {
            this.makeToast('Opss!', 'Não foi possível reenviar o webhook do pedido!', 'danger');
          }).finally(() => {
            this.$store.dispatch('endLoader');
          })
      }
    },
    getNfeCarflax(id) {
      this.$store.dispatch('startLoader');
      this.getNfeCarflaxPaymentId(id)
        .then((response) => {
          if(response.data.error) {
            this.makeToast('Opss!', response.data.message, 'danger');
            this.$store.dispatch('endLoader');
          } else {
            this.makeToast('Sucesso!', 'NF-e salva com sucesso!', 'success');
            this.list();
          }
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
          this.makeToast('Opss!', 'Não foi possível buscar a NF-e do pedido!', 'danger');
        });
    },
    returnPayment(item, card = true) {
      if (Number.isFinite(item.totalValue) && Number.isInteger(item.totalValue)) {
        item.totalValue = item.totalValue+'.00'
      }

      this.paymentReturn = item;

      if(card) {
        this.paymentReturnValue = item.totalValue;
        this.$bvModal.show('modalReturnPayment');
        return;
      }

      const data = {
        payment: this.paymentReturn,
        value: this.paymentReturnValue
      }

      this.$store.dispatch('startLoader');
      this.sendReturnPayment(data)
        .then((response) => {
           this.$store.dispatch('endLoader');
          if(response.data.error == false) {
            this.$bvModal.hide('modalReturnPayment');

            this.makeToast('Sucesso', 'Estorno feito com sucesso!');
            this.list();
          } else {
            var msg = 'Não foi possível fazer o estorno do pedido!';
            if(this.paymentReturn.paymentType == 'credit_card' || this.paymentReturn.paymentType == 'pix') {
              msg = 'Não foi possível fazer o estorno do pedido, favor verificar o saldo da Iugu para tentar novamente!';
            }
            this.makeToast('Opss!', msg, 'danger');
          }
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
          this.makeToast('Opss!', 'Não foi possível fazer o estorno do pedido!', 'danger');
        });
    },
    formatarBalconista(id) {
      const balconistaEncontrado = this.balconistas.find(balconista => balconista.id === id);
      return balconistaEncontrado ? balconistaEncontrado.name : '-';
    },
    getAll(){
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/getClerk', this.userTypeId())
        .then((response) => {
          this.balconistas = response.data;

          this.list();
        })
        .catch(() => {
          this.makeToast('Erro', 'Houve um erro ao trazer os dados', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
    },
    timerFunction() {
      const myTimer = 60000 * 3;
      this.timeInterval = setInterval(() => {
        this.list();
      }, myTimer);
    },
    stopTimerFunction() {
      clearInterval(this.timeInterval);
    },
    enviarCitel(id, lojistaId) {
      this.$store.dispatch('startLoader');
      if(lojistaId == 4439) {
        this.enviarPedidoCitelEstrela(id)
          .then((response) => {
            this.$store.dispatch('endLoader');
            if(response.data.error == false) {
              this.makeToast('Sucesso', 'Pedido enviado com sucesso!');
              this.list();
            } else {
              this.makeToast('Opss!', 'Não foi possível enviar o pedido para Citel!', 'danger');
            }
          })
          .catch(() => {
            this.$store.dispatch('endLoader');
            this.makeToast('Opss!', 'Não foi possível enviar o pedido para Citel!', 'danger');
          });
      } else if(lojistaId == 4477) {
        this.enviarPedidoCitelCarflax(id)
          .then((response) => {
            this.$store.dispatch('endLoader');
            if(response.data.error == false) {
              this.makeToast('Sucesso', 'Pedido enviado com sucesso!');
              this.list();
            } else {
              this.makeToast('Opss!', 'Não foi possível enviar o pedido para Citel!', 'danger');
            }
          })
          .catch(() => {
            this.$store.dispatch('endLoader');
            this.makeToast('Opss!', 'Não foi possível enviar o pedido para Citel!', 'danger');
          });
      } else if(lojistaId == 4465) {
        this.enviarPedidoCitelAtena(id)
          .then((response) => {
            this.$store.dispatch('endLoader');
            if(response.data.error == false) {
              this.makeToast('Sucesso', 'Pedido enviado com sucesso!');
              this.list();
            } else {
              this.makeToast('Opss!', 'Não foi possível enviar o pedido para Citel!', 'danger');
            }
          })
          .catch(() => {
            this.$store.dispatch('endLoader');
            this.makeToast('Opss!', 'Não foi possível enviar o pedido para Citel!', 'danger');
          });
      } else {
        this.enviarPedidoCitel(id)
          .then((response) => {
            this.$store.dispatch('endLoader');
            if(response.data.error == false) {
              this.makeToast('Sucesso', 'Pedido enviado com sucesso!');
              this.list();
            } else {
              this.makeToast('Opss!', 'Não foi possível enviar o pedido para Citel!', 'danger');
            }
          })
          .catch(() => {
            this.$store.dispatch('endLoader');
            this.makeToast('Opss!', 'Não foi possível enviar o pedido para Citel!', 'danger');
          });
      }
    },
    statusPedidoLoja(id, status, valor=null) {

      const data = {
        id: id,
        status: status,
        valor: valor
      }

      this.$store.dispatch('startLoader');
      this.updateOrderStatusLoja(data)
        .then(() => {
          this.makeToast('Sucesso', 'Status do pedido atualizado com sucesso');
          this.list();
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    list(itensPerPage = 15) {
      if (this.loading) return;

      this.loading = true;
      const { clientName, orderNumber, vendedor, startDate, endDate, status, paymentType } =
        this.fields;

      this.getAppOrders({
        currentPage: this.pagination.currentPage,
        userId: this.userTypeId(),
        clerkId: this.whatClerkPermission(),
        clientName,
        vendedor,
        orderNumber,
        startDate,
        endDate,
        status,
        paymentType,
        itensPerPage
      })
        .then((response) => {
          const { perPage, total, data } = response.data.data || {};

          this.pagination.itemsPerPage = perPage || 15;
          this.pagination.total = total || 0;

          this.$set(this.table, 'records', data || []);

          if(itensPerPage > 15) {
            this.gerarExcel();
          }
        })
        .catch(() => {
          this.loading = false;
          this.makeToast('Erro', 'Houve um erro ao trazer os pedidos', 'danger');
        })
        .finally(() => {
          this.loading = false;
          this.$store.dispatch('endLoader');
        });
    },
    generateProductsPayment() {
      if (this.loading) return;

      this.$store.dispatch('startLoader');
      const { clientName, orderNumber, vendedor, startDate, endDate, status, paymentType } =
        this.fields;

      this.getAppProductsOrders({
        userId: this.userTypeId(),
        clerkId: this.whatClerkPermission(),
        clientName,
        vendedor,
        orderNumber,
        startDate,
        endDate,
        status,
        paymentType
      })
        .then((response) => {
          if(response.data.data.products.length > 0) {
            const clientsData = XLSX.utils.json_to_sheet(response.data.data.products);
            const excelFile = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(excelFile, clientsData, 'Lista de clientes');

            const currentDate = new Date().toLocaleDateString('pt-BR');
            const fileName = `Lista de produtos por pedidos - ${currentDate}`;

            setTimeout(() => {
              this.generatingSpreadsheet = false;
            }, 1000);

            XLSX.writeFile(excelFile, `${fileName}.xlsx`);
          } else {
            this.makeToast('Erro', 'A busca retornou 0 produtos!', 'danger');
          }
        })
        .catch(() => {
          this.makeToast('Erro', 'Houve um erro ao trazer os produtos', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    updateStatus({ id, newStatus, popover = false}) {
      if (newStatus == 1) {
        this.makeToast('Erro', 'Não pode alterar para o mesmo status (Aguardando Pagamento)', 'danger');
        return;
      }

      if (popover == true) {
        if (this.received.name == '' || this.received.cpf == '') {
          this.makeToast('Erro', 'Informe o NOME e CPF de quem recebeu/retirou o pedido!', 'danger');
          return;
        }
      } else {
        this.received.name = '';
        this.received.cpf = '';
        this.received.payment = '';
      }

      this.$store.dispatch('startLoader');
      this.updateOrderStatus({ userId: this.userTypeId(), id, newStatus, received: this.received })
        .then(() => {
          this.cancelOrderEdit(id);
          this.setEditedValuesToOrderInTable(id, { newStatus });

          this.makeToast('Sucesso', 'Status do pedido atualizado com sucesso');
        })
        .catch((error) => {
          this.makeToast('Erro', error.response.data.message || 'Houve um erro ao atualizar o status do pedido os pedidos', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.isEditing = false;
        });
    },
    generateSpreadsheet() {
      if (!this.table.records || !this.table.records.length) return;

      if(this.pagination.itemsPerPage > 1) {
        this.list(this.pagination.total);
      } else {
        this.gerarExcel();
      }
    },
    gerarExcel() {
      this.generatingSpreadsheet = true;

      const nomeArquivo = this.dadosUsuario.tipo_usuario_id == 10 ?
        this.dadosUsuario.lojista.nome_fantasia :
        this.dadosUsuario.informacoes.nome_fantasia;

      const clientsData = XLSX.utils.json_to_sheet(
        this.convertColumnsNames(this.table.records)
      );
      const excelFile = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(excelFile, clientsData, 'Lista de clientes');

      const currentDate = new Date().toLocaleDateString('pt-BR');
      const fileName = `Lista de pedidos - ${nomeArquivo} - ${currentDate}`;

      setTimeout(() => {
        this.generatingSpreadsheet = false;
      }, 1000);

      XLSX.writeFile(excelFile, `${fileName}.xlsx`);
    },
    /**
     * @param {Array} records
     * @returns {Array}
     */
    convertColumnsNames(records) {
      if (!records || !records.length) return [];

      const returnArray = [];

      records.forEach((record) => {
        const cell = {};

        Object.keys(record).forEach((key) => {
          const tableColumn = this.table.headers.find((x) => x.key === key);

          if (key === 'status') {
            cell[`${tableColumn.label}`] = this.getOrderStatusText(record[key]);
            return;
          }

          if (key === 'paymentType') {
            cell[`${tableColumn.label}`] = this.getPaymentTypeText(record[key]);
            return;
          }

          if (key === 'totalValue') {
            cell[`${tableColumn.label}`] = formatNumber(record[key]);
            return;
          }

          if(tableColumn && tableColumn.label) {
            cell[`${tableColumn.label}`] = record[key];
          }
        });

        returnArray.push(cell);
      });

      return returnArray;
    },
    confirmUpdateStatusWhenFinishedorCancel(orderId, tipo='') {
      this.tipoPedidoLoja = tipo == 'shopkeeper' ? true : false;
      this.currentOrderBeingEditedId = orderId;
      this.received.name = '';
      this.received.cpf = '';
      this.showConfirmationPopover = true;
    },
    /**
     * @param {Number | String} orderId
     */
    editOrder(orderId) {
      this.isEditing = true;
      const order = this.table.records.find((x) => x.id === orderId);
      this.statusNow = order.status;
      const index = this.table.records.indexOf(order);
      this.$set(this.table.records[`${index}`], 'editing', true);
      const { status } = order;
      this.$set(this.fields.selectedOrders, `${orderId}`, {
        orderId,
        newStatus: status,
      });
    },
    cancelOrderEdit(orderId) {
      this.isEditing = false;
      const order = this.table.records.find((x) => x.id === orderId);
      const index = this.table.records.indexOf(order);

      this.$set(this.table.records[`${index}`], 'editing', false);

      delete this.fields.selectedOrders[`${orderId}`];
    },
    /**
     * Caso haja sucesso na atualização de um produto selecionado, para não precisarmos carregar
     * a tabela toda novamente, atualizamos diretamente o elemento na tabela
     */
    setEditedValuesToOrderInTable(orderId, { newStatus }) {
      const order = this.table.records.find((x) => x.id === orderId);
      const index = this.table.records.indexOf(order);

      this.$set(this.table.records[`${index}`], 'status', newStatus);
    },
    handleOrderNumber() {
      if (!this.fields.orderNumber) return;
      this.$set(this.fields, 'orderNumber', Math.abs(this.fields.orderNumber));
    },
    addStatus(userType) {
      if (this.fields.status.includes(userType)) {
        const index = this.fields.status.indexOf(userType);
        this.fields.status.splice(index, 1);
        this.list();
        return;
      }

      this.fields.status.push(userType);
      this.list();
    },
    addStatusPayment(userType) {
      if (this.fields.paymentType.includes(userType)) {
        const index = this.fields.paymentType.indexOf(userType);
        this.fields.paymentType.splice(index, 1);
        this.list();
        return;
      }

      this.fields.paymentType.push(userType);
      this.list();
    },
    addAllStatus() {
      Object.values(ORDER_STATUS).forEach((value) => {
        if (this.fields.status.includes(value)) return;

        this.fields.status.push(value);
      });

      this.list();
    },
    addAllStatusPayment() {
      Object.values(PAYMENT_METHODS).forEach((value) => {
        if (this.fields.paymentType.includes(value)) return;

        this.fields.paymentType.push(value);
      });

      this.list();
    },
    getPaymentTypeText(type) {
      const texts = {
        credit_card: 'Cartão de crédito',
        pix: 'Pix',
        all: 'Boleto',
        wallet: 'Carteira',
        shopkeeper: 'Pagamento na entrega/loja'
      };

      return texts[type] || 'N/A';
    },
    getOrderStatusText(status, tipo='') {

      var payment = 'Aguardando pagamento';
      if(tipo == 'shopkeeper') {
        payment = 'Aguardando aprovação';
      }

      const texts = {
        [ORDER_STATUS.WAITING_PAYMENT]: payment,
        [ORDER_STATUS.SEPARATING_ORDER]: 'Separando pedido',
        [ORDER_STATUS.SENT]: 'Saiu para entrega',
        [ORDER_STATUS.READY_FOR_PICKUP]: 'Pronto para retirada',
        [ORDER_STATUS.DELIVERED]: 'Entregue',
        [ORDER_STATUS.CANCELED]: 'Cancelado',
        [ORDER_STATUS.EXPIRED]: 'Expirado',
        [ORDER_STATUS.IN_ANALYSIS]: 'Em análise',
        [ORDER_STATUS.REPROVED]: 'Reprovado',
      };

      return texts[status] || 'N/A';
    },
    getPaymentStatusText(status) {

      const texts = {
        [PAYMENT_METHODS.PIX]: 'Pix',
        [PAYMENT_METHODS.BOLETO]: 'Boleto',
        [PAYMENT_METHODS.CREDIT_CARD]: 'Cartão de crédito',
        [PAYMENT_METHODS.WALLET]: 'Carteira',
        [PAYMENT_METHODS.SHOPKEEPER_PAYMENT]: 'Pagamento para o lojista'
      };

      return texts[status] || 'N/A';
    },
    colorText(status) {
      if (status >= 2 && status <= 4) return 'c-green';
      if (status == 6) return 'red';
      return 'c-black';
    },
    printLabel(orderId) {
      this.printing = true;

      this.printMelhorEnvioLabel({
        construpUserId: this.userTypeId(),
        paymentId: orderId,
      })
        .then((response) => {
          const { printUrl } = response.data.data;

          window.open(printUrl, '_blank');
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao gerar a etiqueta do pedido',
            'danger'
          );
        })
        .finally(() => {
          this.printing = false;
        });
    },
    sendFreight(orderId) {
      this.$refs.sendFreight.toggleOpen({ orderId });
    },
    getTrackingUrl(orderId) {
      this.gettingTrack = true;

      this.getTrackingMelhorEnvioUrl({
        construpUserId: this.userTypeId(),
        paymentId: orderId,
      })
        .then((response) => {
          const { trackingUrl } = response.data.data[0];

          window.open(trackingUrl, '_blank');
        })
        .catch((error) => {
          this.makeToast('Erro', error.response.data.message, 'danger');
        })
        .finally(() => {
          this.gettingTrack = false;
        });
    },
    userTypeId() {
      return this.$route.meta.userType == UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },
    whatClerkPermission(){
      if(this.$route.meta.userType  == UserTypes.BALCONISTA){
        const permissionClerk = JSON.parse(localStorage.getItem('permissionClerk'));
        const permission = permissionClerk.find(element => element.name == NamePermission.PEDIDOS);
        const editStatus = permissionClerk.find(element => element.name == NamePermission.PEDIDO_STATUS);

        if(editStatus.type == TypePermission.TODOS){
          return this.editStatusClerk = true;
        }

        if(permission.type == TypePermission.BALCONISTA){
          return this.dadosUsuario.id;
        }
      }
      return '';
    },
    isEdit(value){
      if(this.$route.meta.userType == UserTypes.BALCONISTA){
        return this.editStatusClerk;
      }
      return !value.editing;
    },
    addInvoice(order) {
      this.$refs.invoiceOrder.toggleOpen({
        order: order
      })
    },
    getHeaders() {
      this.table.headers = [
        {
          key: 'index',
          thClass: 'd-none',
          tdClass: 'd-none',
        },
        {
          key: 'date',
          label: 'Data',
          sortable: true,
        },
        {
          key: 'uuid',
          label: 'Pedido',
          sortable: true,
        },
        {
          key: 'status',
          label: 'Status Pagamento',
          sortable: true,
        },
        {
          key: 'clientName',
          label: 'Cliente',
          sortable: true,
          headerClass: "d-none d-md-table-cell",
          tdClass: "d-none d-md-table-cell",
          thClass: "d-none d-md-table-cell",
        },
        {
          key: 'paymentType',
          label: 'Forma de Pagamento',
          sortable: true,
          headerClass: "d-none d-md-table-cell",
          tdClass: "d-none d-md-table-cell",
          thClass: "d-none d-md-table-cell",
        },
        {
          key: 'origem',
          label: 'Origem',
          sortable: true,
          headerClass: "d-none d-md-table-cell",
          tdClass: "d-none d-md-table-cell",
          thClass: "d-none d-md-table-cell",
        },
        {
          key: 'orcamentoId',
          label: this.userTypeId() === 4477 ? 'Nf-e' : 'Orcamento',
          sortable: true,
          headerClass: "d-none d-md-table-cell",
          tdClass: "d-none d-md-table-cell",
          thClass: "d-none d-md-table-cell",
        },
        {
          key: 'totalValue',
          label: 'Valor total',
          sortable: true,
          headerClass: "d-none d-md-table-cell",
          tdClass: "d-none d-md-table-cell",
          thClass: "d-none d-md-table-cell",
        },
        {
          key: '',
          label: 'Status Entrega',
          sortable: true,
        },
        {
          key: '',
          label: 'Status Pedidos',
          sortable: true,
        },
        {
          key: 'actions',
          label: 'Ações',
          sortable: false,
        },
      ];
    }
  },
};
</script>

<style scoped>
.c-black {
  color: black;
}
.c-green {
  color: green;
}
.countdown {
  margin-top: 10px;
  margin-left: -68px;
}
</style>
